export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_293.98a4f1df.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};